// 平台
import * as type from "../mutation-types";
import AES from "@/mixins/AES";
const state = {
  data: window.localStorage.getItem("platform") || "",
};

const getters = {
  getPlatform: (state) => state.data,
};

const mutations = {
  [type.USER_OUT_LOGIN](state) {
    state.data = null;
  },
};

const actions = {
  onUse(response) {
    window.localStorage.setItem("platform", response);
  },
  outLogin({ commit }) {
    if (window.localStorage.getItem("platform")) {
      let temp = JSON.parse(
        AES.decrypt(window.localStorage.getItem("platform"))
      );
      temp.forEach((item) => {
        window.localStorage.removeItem(`platform${item.value}shop`);
      });
    }

    commit(type.USER_OUT_LOGIN);
    window.localStorage.removeItem("platform");
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
